import posthog from 'posthog-js';
import { MemberData, WorkspaceData } from '~/api';
import {
  AppContexts,
  isDebugLocalStorageKeyOn,
  isDevelopmentMode,
  isInternalUser,
  isScalekitPlatformProductionEnvironment,
  isStagingMode
} from '~/utils/commonUtils.ts';
import { globalStore } from '~/stores';

const POSTHOG_API_HOST_DOMAIN = 'https://app.posthog.com';
const POSTHOG_PROXY_DOMAIN = 'https://ph.scalekit.com';

const isPosthogDisabled = () => {
  if (isDebugLocalStorageKeyOn()) {
    return false;
  }

  return (
    isDevelopmentMode() ||
    isStagingMode() ||
    (!isScalekitPlatformProductionEnvironment() &&
      (globalStore.appContext === AppContexts.HOSTED_AUTH_PAGES ||
        globalStore.appContext === AppContexts.ENV_APP_PAGES))
  );
};

function initialize() {
  if (isPosthogDisabled()) {
    return;
  }
  posthog.init(import.meta.env.VITE_POSTHOG_PUBLIC_TOKEN, {
    api_host: isDebugLocalStorageKeyOn()
      ? POSTHOG_PROXY_DOMAIN
      : POSTHOG_API_HOST_DOMAIN
  });
}

function identifyUser(memberData: MemberData) {
  if (isInternalUser(memberData.email)) {
    posthog.opt_out_capturing();
  } else {
    posthog.identify(memberData.externalId);
  }
}

function groupIdentify(workspaceData: WorkspaceData) {
  posthog.group('workspace', workspaceData.id, {
    name: workspaceData.displayName
  });
}

function resetIdentity() {
  posthog.reset();
}

function registerPosthogProperty(property: Record<string, any>) {
  posthog.register({
    ...property
  });
}

function getInitializer() {
  let isInitialized = false;
  return () => {
    if (isInitialized) {
      return;
    }
    initialize();
    isInitialized = true;
  };
}

const initPosthog = getInitializer();

export {
  initPosthog,
  identifyUser,
  groupIdentify,
  resetIdentity,
  registerPosthogProperty
};
